module.exports = __webpack_public_path__ + "media/pick_axe03.54f89237.mp3";